import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  SERVICES_PAGE_ADD_PATH,
  SERVICES_PAGE_PATH,
  SERVICES_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const ServicesDetailsPage = Loadable(React.lazy(() => import("./View")));
const ServicesDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const ServicesRoute: IRouteItem = {
  path: SERVICES_PAGE_PATH,
  element: React.createElement(ServicesDetailsPage),
  name: "Services Listing",
  children: [
    {
      name: "Add / Update",
      path: SERVICES_PAGE_ADD_PATH,
      element: React.createElement(ServicesDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: SERVICES_PAGE_UPDATE_PATH,
      element: React.createElement(ServicesDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
